import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome, FaSignOutAlt } from "react-icons/fa";
import { ASSETS } from "../config/assets";
import { businessPath, DEFAULT_PROJECT_ID } from "../config/businessMenu";
import {
  canAccessAllProjects,
  clearSession,
  getToken,
  getUserProjectIds,
  getDefaultProjectId,
  isAdminUser,
  isSuperAdminUser,
} from "../utils/auth";

const Unauthorized = () => {
  const navigate = useNavigate();
  const mappedIds = getUserProjectIds();
  const projectId =
    mappedIds[0] || getDefaultProjectId() || DEFAULT_PROJECT_ID;
  const hasSession = Boolean(getToken());
  const canOpenAllProjects = canAccessAllProjects();
  const canOpenProject =
    isSuperAdminUser() || mappedIds.length > 0 || (isAdminUser() && mappedIds.length > 0);

  const onLogout = () => {
    clearSession();
    navigate("/login", { replace: true });
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-card">
        <img
          src={ASSETS.notFound}
          alt=""
          className="unauthorized-illustration"
        />
        <h1>Access not allowed</h1>
        <p>
          You do not have permission to view this page. Contact your administrator
          if you need access.
        </p>
        <div className="unauthorized-actions">
          {hasSession ? (
            <>
              {canOpenAllProjects ? (
                <Link to="/all-projects" className="biz-btn-primary">
                  <FaHome />
                  All projects
                </Link>
              ) : canOpenProject ? (
                <Link
                  to={businessPath(projectId, "dashboard")}
                  className="biz-btn-primary"
                >
                  <FaHome />
                  Go to Dashboard
                </Link>
              ) : null}

              <button
                type="button"
                className="biz-btn-secondary"
                onClick={onLogout}
              >
                <FaSignOutAlt />
                Log out
              </button>
            </>
          ) : (
            <Link to="/login" className="biz-btn-primary">
              Sign in
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
